import { Labels } from '../types/labels.types';

export class LabelParser {
    private labels: Labels;

    public constructor(labels: Labels) {
        this.labels = labels;
    }

    public getLabel(key: keyof Labels): string {
        return this.labels ? (this.labels[key] ?? key) : key;
    }
}
